module.exports = __webpack_public_path__ + "static/img/xi_3.7b76bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_3.png
// module id = VPbQ
// module chunks = 1